import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phone",
  "use": "phone-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 11\" id=\"phone\">\n  <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11 8.24v1.65A1.1 1.1 0 0 1 9.8 11c-1.7-.18-3.34-.76-4.78-1.69A10.77 10.77 0 0 1 1.7 6 10.91 10.91 0 0 1 0 1.2 1.1 1.1 0 0 1 1.1 0h1.66c.56 0 1.03.4 1.11.95.07.53.2 1.05.39 1.55.15.4.05.86-.25 1.17l-.7.7a8.84 8.84 0 0 0 3.31 3.3l.7-.7c.31-.3.77-.4 1.17-.24.5.19 1.03.32 1.56.39.55.07.96.56.95 1.12Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol